import { APIClient } from '../api_helper';
import * as url from './url_helper';

const config = require('../../config');
const INSPECTION_BASE = config.api.REACT_APP_SPED_NORMATIVE_API_URL;

const apiClient = new APIClient();

export const getFiscalizerList = () => {
	return apiClient.get(`${INSPECTION_BASE}${url.GET_FISCALIZERS}`);
};

export const getFiscalizerByIdApi = id => {
	return apiClient.get(`${INSPECTION_BASE}${url.GET_FISCALIZER}${id}`);
};

export const addNewFiscalizerApi = fiscalizer => {
	return apiClient.create(`${INSPECTION_BASE}${url.POST_FISCALIZER}`, fiscalizer);
};

export const updateFiscalizerApi = fiscalizer => {
	return apiClient.put(
		`${INSPECTION_BASE}${url.PUT_FISCALIZER}${fiscalizer._id}`,
		fiscalizer
	);
};

export const deleteFiscalizerApi = fiscalizerId => {
	return apiClient.delete(`${INSPECTION_BASE}${url.DELETE_FISCALIZER}${fiscalizerId}`);
};
